import { render } from "./Content_recall.vue?vue&type=template&id=0d49f6dc&scoped=true"
import script from "./Content_recall.vue?vue&type=script&lang=js"
export * from "./Content_recall.vue?vue&type=script&lang=js"

import "./Content_recall.vue?vue&type=style&index=0&id=0d49f6dc&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d49f6dc"]])